// src/data/announcementsData.js
// The announcements as they existed before the page moved to Firestore.
//
// Two jobs:
//   1. Fallback — the public page renders these if Firestore is empty or
//      unreachable, so the Announcements page can never go blank.
//   2. Import source — the one-time "Import existing announcements" button in
//      the admin panel copies these into Firestore.
//
// Images are referenced by `legacyImageKey` (see legacyAnnouncementImages.js)
// rather than imported here, so this file stays plain data.

export const STATIC_ANNOUNCEMENTS = [
  // ── News ──────────────────────────────────────────────────────────────────
  {
    type: "news",
    title: "Prime Valor Caribbean Cup 2026 Expands",
    excerpt: "The Caribbean Cup 2026 returns bigger than ever.",
    body: "The Caribbean Cup 2026 returns bigger than ever.\n\nThis year introduces two new modes — Warzone & 1v1, alongside the traditional CDL format, creating a true multi-mode championship.\n\nA new Nationals Cup will also be featured, bringing country vs country competition into the spotlight.\n\nMore competition. More rivalry. One Caribbean champion.",
    date: "March 2026",
    author: "Prime Valor",
    category: "Tournament",
    legacyImageKey: "caribbean-cup",
    featured: true,
  },
  {
    type: "news",
    title: "Marvel Rivals Division Announcement",
    excerpt: "Prime Valor is expanding into Marvel Rivals. We're looking for talented players to join our new competitive division.",
    body: "",
    date: "January 15, 2025",
    author: "Prime Valor",
    category: "Announcement",
    legacyImageKey: "marvel",
    featured: false,
  },
  {
    type: "news",
    title: "Prime Valor Draft Wars Announced",
    excerpt: "Prime Valor introduces Draft Wars, a new CDL tournament format where selected Franchise Owners build their teams by purchasing players using a set budget.",
    body: "Prime Valor introduces Draft Wars, a new CDL tournament format where selected Franchise Owners build their teams by purchasing players using a set budget.\n\nThis event brings strategy, competition, and team-building into one high-stakes showdown.\n\nMore details coming soon. 🔥",
    date: "March 2026",
    author: "Prime Valor",
    category: "Announcement",
    legacyImageKey: "draft-wars",
    featured: false,
  },

  // ── Tournaments ───────────────────────────────────────────────────────────
  {
    type: "tournament",
    title: "1v1 Tournament",
    date: "2026",
    eventStatus: "upcoming",
    prizePool: "TBA",
    format: "1v1",
    game: "Call of Duty: Black Ops 7",
    legacyImageKey: "1v1",
    excerpt: "Solo competition where the best individual player claims the crown.",
    featured: false,
  },
  {
    type: "tournament",
    title: "Female 1v1 Tournament",
    date: "2026",
    eventStatus: "upcoming",
    prizePool: "TBA",
    format: "1v1",
    game: "Call of Duty: Black Ops 7",
    legacyImageKey: "1v1-female",
    excerpt: "Dedicated 1v1 competition for female players across the Caribbean.",
    featured: false,
  },
  {
    type: "tournament",
    title: "1v1 Special Edition",
    date: "2026",
    eventStatus: "completed",
    prizePool: "TBA",
    format: "1v1",
    game: "Call of Duty: Black Ops 7",
    legacyImageKey: "1v1-se",
    excerpt: "A special edition 1v1 event with elevated stakes and format.",
    featured: false,
  },
  {
    type: "tournament",
    title: "CDL Academy 1v1",
    date: "2026",
    eventStatus: "upcoming",
    prizePool: "TBA",
    format: "1v1",
    game: "Call of Duty: Black Ops 7",
    legacyImageKey: "1v1-academy",
    excerpt: "Academy division 1v1 challenge — the next generation steps up.",
    featured: false,
  },
  {
    type: "tournament",
    title: "3v3 Tournament",
    date: "2026",
    eventStatus: "completed",
    prizePool: "TBA",
    format: "3v3",
    game: "Call of Duty: Black Ops 7",
    legacyImageKey: "3v3",
    excerpt: "3v3 team competition testing coordination and firepower.",
    featured: false,
  },
  {
    type: "tournament",
    title: "Duos Tournament",
    date: "2026",
    eventStatus: "completed",
    prizePool: "TBA",
    format: "2v2",
    game: "Call of Duty: Black Ops 7",
    legacyImageKey: "duos",
    excerpt: "Two-player duos format — find your partner and compete.",
    featured: false,
  },
  {
    type: "tournament",
    title: "Trios Tournament",
    date: "2026",
    eventStatus: "completed",
    prizePool: "TBA",
    format: "3v3",
    game: "Call of Duty: Black Ops 7",
    legacyImageKey: "trios",
    excerpt: "Trios format bringing three-player squads into the spotlight.",
    featured: false,
  },
  {
    type: "tournament",
    title: "Trios Competition",
    date: "2026",
    eventStatus: "upcoming",
    prizePool: "TBA",
    format: "3v3",
    game: "Call of Duty: Black Ops 7",
    legacyImageKey: "trios-comp",
    excerpt: "Competitive trios event — build your squad and battle for the win.",
    featured: false,
  },
];
